import { render, staticRenderFns } from "./Content_analysis.vue?vue&type=template&id=38d3815c"
import script from "./Content_analysis.vue?vue&type=script&lang=js"
export * from "./Content_analysis.vue?vue&type=script&lang=js"
import style0 from "./Content_analysis.vue?vue&type=style&index=0&id=38d3815c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports